module.exports = __webpack_public_path__ + "img/2.36575efc.webp";